import { HelpInbox } from '@/components/help/help-inbox';

/** Help requests to the Nirvik Ready team. */
export function AdminHelpPage() {
  return <HelpInbox scope={{ kind: 'platform' }} />;
}
